export const locale = {
    lang: 'fr',
    data: {
        HEADER: {
            'MEGA_MENU': 'Mega Menu',
            'QUICK_LINK': 'Quick Link',
        },
        SIDENAV: {
            DASHBOARDS: 'Tableaux de bord',
            MAILBOX: 'boîte de réception',
            CHAT: 'Bavarder',
            KNOWLADGE_BASE: 'Base de connaissances',
            CALENDAR: 'Calendrier',
            CONTACTS: 'Contacts',
        },
    }
};
